import React, { useRef, useEffect, useState } from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import { Power3, gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

const media = {
  medium: '@media(min-width:700px)',
  large: '@media(min-width:1200px)',
  xLarge: '@media(min-width:1800px)'
}

const StudentListStyles = styled.ul`
  font-size: 7.5vw;
  list-style: none;
  padding: 0;
  margin: 0;
  background: var(--black);
  z-index: 10;
  position: relative;
  padding-bottom:4vh;
  
  /* position:fixed; */
  /* bottom:0; */
  /* width:100vw; */
  /* z-index:-2; */
  

  ${media.large} {
    font-size: 9.5vw;
  }

  ${media.xLarge} {
    font-size: 9.5vw;
  }
`

const StudentItemStyles = styled.li`
  font-weight: 200;
  letter-spacing: -0.03em;
  text-transform: uppercase;
  line-height: 0.8em;
  overflow: hidden;
  border-bottom: 1px solid rgb(50, 50, 50);

  .student-hero {
    max-height: 1em;
    margin: 0 0.125em;
    transform: translateY(0.125em);
    border-radius: 6px;
  }
  a {
    color: var(--light);
    display: block;
    text-decoration: none;
    padding: 0.1em 0.25em 0.25em 1em;
    text-align: center;
    line-height: 1;

    font-variation-settings: "wght" 100;
    transition: all 0.12s ease-in-out;
    &:hover {
      background: var(--black);
      color: var(--light);
    }

    &:active {
      transform: scale(0.9);

    }
  }
  &:last-child {
    border-bottom: none;
  }
  
`

export default function NextStudent ({ students, next }) {
  if (typeof window !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger)
    gsap.config({ nullTargetWarn: false })
  }

  let nextLink = useRef(null)

  useEffect(() => {
    gsap.from(nextLink, {
      scrollTrigger: {
        trigger: nextLink,
        start: 'top 90%',
        end: () => `+=${nextLink.offsetHeight}`,
        scrub: true
      },
      opacity: '0.0',
      y: '40'
    })
  })

  if (next == null) {
    return (
      <>
        <StudentListStyles>
          <StudentItemStyles className="student-list-item">
            <Link className="studentLink next-student-link" ref={el => { nextLink = el }} to={`/students/${students[0].slug.current}`}>
              {students[0].first_name}
              <img
                className="student-hero"
                src={students[0].hero_image.asset.fluid.src}
                alt=""
              />
              {students[0].last_name}
            </Link>
          </StudentItemStyles>
        </StudentListStyles>
      </>
    )
  }
  return (
    <>
      <StudentListStyles>
        <StudentItemStyles className="student-list-item">
          <Link className="studentLink next-student-link" ref={el => { nextLink = el }} to={`/students/${next.slug.current}`}>
            {next.first_name}
            <img
              className="student-hero"
              src={next.hero_image.asset.fluid.src}
              alt=""
            />
            {next.last_name}
          </Link>
        </StudentItemStyles>
      </StudentListStyles>
    </>
  )
}
